import { useEffect } from 'react'
import '../styles/ShortcutsHelp.css'

const isMac = typeof navigator !== 'undefined' && /mac|iphone|ipad/i.test(navigator.platform || navigator.userAgent || '')
const MOD = isMac ? '⌘' : 'Ctrl'

const GROUPS = [
  {
    title: 'Navigation & recherche',
    items: [
      { keys: [MOD, 'K'], label: 'Palette de commandes' },
      { keys: [MOD, 'F'], label: 'Recherche (région, pays, climat, météo, organisation, population)' },
      { keys: ['Z/Q/S/D', 'ou', 'W/A/S/D'], label: 'Déplacer la carte' },
      { keys: ['Molette'], label: 'Zoom' },
    ],
  },
  {
    title: 'Sélection',
    items: [
      { keys: ['Clic'], label: 'Ouvrir la fiche d\'une région' },
      { keys: ['Maj', 'Clic'], label: 'Ajouter / retirer de la multi-sélection' },
      { keys: [MOD, 'Clic'], label: 'Ajouter / retirer de la multi-sélection' },
      { keys: ['Clic droit'], label: 'Menu : copier les coordonnées / partager la position' },
    ],
  },
  {
    title: 'Outils de dessin (Plan, Construction, Règle)',
    items: [
      { keys: ['Échap'], label: 'Quitter l\'outil actif' },
      { keys: [MOD, 'Z'], label: 'Annuler le dernier point (règle / infra / plan)' },
      { keys: ['Flèches'], label: 'Déplacer le dernier point (Maj = pas fin)' },
      { keys: ['Clic droit'], label: 'Effacer / supprimer un point' },
    ],
  },
]

// Keyboard & mouse cheat-sheet (opened from the shortcut hints "?").
export default function ShortcutsHelp({ open, onClose }) {
  useEffect(() => {
    if (!open) return
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null
  return (
    <div className="pr-modal-overlay" onClick={onClose}>
      <div className="pr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pr-modal-header">
          <h2 className="pr-modal-title">Raccourcis</h2>
          <button type="button" className="pr-modal-close" onClick={onClose} aria-label="Fermer">×</button>
        </div>
        <div className="pr-modal-body">
          {GROUPS.map((g) => (
            <div className="shortcuts-help-group" key={g.title}>
              <h3>{g.title}</h3>
              {g.items.map((it, i) => (
                <div className="shortcuts-help-row" key={i}>
                  <span className="shortcuts-help-keys">
                    {it.keys.map((k, j) => (
                      k === 'ou' ? <span key={j} className="shortcuts-help-sep">ou</span> : <kbd key={j}>{k}</kbd>
                    ))}
                  </span>
                  <span className="shortcuts-help-label">{it.label}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
